import { ComponentProps, useMemo } from 'react';
import { TextField, validators } from '@vst/beam';

interface AddressInputProps extends ComponentProps<typeof TextField> {
  validation?: {
    required: string;
  };
}

export const AddressInput = (props: AddressInputProps) => {
  const { validation, ...textFieldProps } = props;

  const validationRules = useMemo(() => {
    const validationRules = [];
    if (validation?.required) {
      validationRules.push(
        validators.required({ message: validation.required })
      );
    }
    return validationRules;
  }, [validation]);

  return (
    <TextField
      data-cy={textFieldProps.name}
      labelProps={{ showStar: false }}
      validationRules={validationRules}
      required={!!validation?.required}
      {...textFieldProps}
    />
  );
};
